import useTableData from "../../../../state/table/UseTableData";

const useSelectIcon = (rowId) => {
  const { tableState, onUpdateSelectedIds } = useTableData();

  const onIconClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (rowId) {
      const newSelectedIds = tableState.selectedIds.includes(rowId)
        ? tableState.selectedIds.filter(id => id !== rowId)
        : [...tableState.selectedIds, rowId];

      onUpdateSelectedIds(newSelectedIds);
    }
  };

  return {
    isSelected: tableState.selectedIds.some(id => id === rowId),
    onIconClicked
  };
};

export default useSelectIcon;